import { connect } from 'react-redux'
import Students from 'modules/Students/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Students)
